import type { GetUserInfoResult } from 'src/app/auth/adapters/knap'
import { HANWHA_ORG_ID } from 'src/app/auth/constants/organization'

export interface IEvaluateHanwhaAccessParams {
  probe: GetUserInfoResult
}

export interface IEvaluateHanwhaAccessReturn {
  allowed: boolean
  isAdmin: boolean
}

export const evaluateHanwhaAccess = (
  params: IEvaluateHanwhaAccessParams,
): IEvaluateHanwhaAccessReturn => {
  const probe = params.probe
  if (probe.status !== 'ok') return { allowed: false, isAdmin: false }
  if (!probe.data.success) return { allowed: false, isAdmin: false }
  const hanwhaMembership = probe.data.organizations.find(
    org => org.id === HANWHA_ORG_ID,
  )
  return {
    allowed: hanwhaMembership !== undefined,
    isAdmin: hanwhaMembership?.role === 1,
  }
}
